import React from 'react';
import { rubriqueService } from 'core/services';
import { useHistory, useParams } from 'react-router';
import FAQRubriqueForm from '../Form';
import { useQuery } from 'core/hooks';
import { RubriqueForm, toRubriqueForm } from 'core/models';
import { PageLoader } from 'components';

type Props = {};

const FAQRubriqueEdit: React.FC<Props> = () => {
    const history = useHistory();
    const { id } = useParams<any>();

    const { data, loading } = useQuery(rubriqueService.getRubrique, id);

    const onSubmit = (rubrique: RubriqueForm) => {
        rubriqueService.editRubrique(id, rubrique).then(() => history.push('/faq/rubriques'));
    };

    if (loading || !data) {
        return <PageLoader loading />;
    }

    return <FAQRubriqueForm defaultValues={toRubriqueForm(data, 'faq')} onEdit={onSubmit}></FAQRubriqueForm>;
};

export default FAQRubriqueEdit;
